import { FuelDivider, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import akad from '@/assets/images/insurance/akad.webp';
import axa from '@/assets/images/insurance/axa.webp';
import ff from '@/assets/images/insurance/ff.webp';
import hdi from '@/assets/images/insurance/hdi.webp';
import sompo from '@/assets/images/insurance/sompo.webp';
import starr from '@/assets/images/insurance/starr.webp';
import sura from '@/assets/images/insurance/sura.webp';
import swissRe from '@/assets/images/insurance/swiss-re.webp';
import skymark from '@/assets/images/risk-management/skymark.webp';

import { Container, Item, LogoList } from './styled';

export const Footer: FC = () => {
  const insurances = [
    { image: sompo, name: 'Sompo' },
    { image: hdi, name: 'HDI' },
    { image: axa, name: 'axa' },
    { image: starr, name: 'Starr' },
    { image: sura, name: 'Sura' },
    { image: akad, name: 'Akad' },
    { image: ff, name: 'FF Seguros' },
    { image: swissRe, name: 'Swiss Re' },
  ];

  const riskManagements = [{ image: skymark, name: 'Skymark' }];

  return (
    <Container>
      <Item>
        <FuelTypography size="caption" weight="medium" color="neutral-default">
          Algumas das seguradoras que aceitam nossa GR:
        </FuelTypography>
        <LogoList>
          {insurances.map(({ image, name }) => (
            <img src={image} alt={name} key={name} />
          ))}
        </LogoList>
      </Item>
      <FuelDivider orientation="vertical" />
      <Item>
        <FuelTypography size="caption" weight="medium" color="neutral-default">
          Nossa GR parceira:
        </FuelTypography>
        <LogoList>
          {riskManagements.map(({ image, name }) => (
            <img src={image} alt={name} key={name} />
          ))}
        </LogoList>
      </Item>
    </Container>
  );
};
